export const text = {
  data: {
    presence: {
      message: "This field can't be blank"
    },
    length: {
      minimum: 2,
      message: 'This field must be at least 2 characters'
    }
  }
}

export const textarea = {
  data: {}
}

export const username = {
  data: {
    presence: {
      message: "Username can't be blank"
    },
    length: {
      minimum: 3,
      message: 'Username must be at least 3 characters'
    }
  }
}

export const email = {
  data: {
    presence: {
      message: "Email can't be blank"
    },
    email: {
      message: 'Please enter a valid email address'
    }
  }
}

export const password = {
  data: {
    presence: {
      message: "Password can't be blank"
    },
    length: {
      minimum: 6,
      message: 'Password must be at least 6 characters'
    }
  }
}

export const url = {
  data: {
    url: true
  }
}

export const loginPassword = {
  data: {
    presence: {
      message: "Password can't be blank"
    }
  }
}

export const changePassword = {
  confirmPassword: {
    equality: {
      attribute: 'password',
      message: 'Passwords do not match'
    }
  }
}
